import { Link } from 'react-router-dom';
import { brandPicture } from '../utils/brandMarkup.mjs';
import './BrandLogo.css';
import { useTheme } from '../design-system/ThemeProvider';

/** Shared artwork and 768px breakpoint with the initial static HTML. */
export default function BrandLogo({ onClick, full = false }: { onClick?: () => void; full?: boolean }) {
  const { resolvedTheme } = useTheme();
  const dark = resolvedTheme === 'dark';
  return <Link to="/cautare" onClick={onClick} className={`brand-logo ${full ? 'brand-logo-full' : ''}`}
    aria-label="LegeaAplicată — Căutare juridică" dangerouslySetInnerHTML={{ __html: full ? brandPicture(dark).replace(/<source[^>]*data-brand-media="\(max-width: 767px\)"[^>]*>/g, '').replaceAll('(min-width: 768px)', '(min-width: 0px)') : brandPicture(dark) }} />;
}
